import { render, staticRenderFns } from "./ClbrtnHistGrid.vue?vue&type=template&id=12440786&scoped=true"
import script from "./ClbrtnHistGrid.vue?vue&type=script&lang=js"
export * from "./ClbrtnHistGrid.vue?vue&type=script&lang=js"
import style0 from "./ClbrtnHistGrid.vue?vue&type=style&index=0&id=12440786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12440786",
  null
  
)

export default component.exports